enum IngestionStatus {
  PENDING = "pending",
  IN_PROGRESS = "started",
  COMPLETED = "completed",
  FAILED = "failed",
}

export const DISPLAY_INGEST_STATUS: Record<IngestionStatus, string> = {
  [IngestionStatus.PENDING]: "Starting...",
  [IngestionStatus.IN_PROGRESS]: "Importing",
  [IngestionStatus.COMPLETED]: "Done",
  [IngestionStatus.FAILED]: "Error",
};

export default IngestionStatus;
